import { SkillMatrixSelfViewTable } from '@/components/SkillMatrixSelfViewTable';

/**
 * `/me/skills` (v0.4 使い勝手フィードバック⑤、D-U7)。自分自身の保有スキル・人材像・育成計画の確認画面。
 *
 * v0.5 スキル登録UI刷新 (docs/design/v05-skill-registration-table-redesign-detail.md) で
 * `SkillMatrixSelfViewTable` (§3/§4-9) に置き換えた。旧実装は独自の読み取り専用テーブル+育成計画の
 * 別セクション表示だったが、要求水準・現状・目標・期限を1つの表に統合し、店長・管理者向けの
 * `SkillMatrixEditor` (EmployeeDetailPage.tsx/Drawer) と同じデータ・同じ選定ロジック
 * (`useSkillMatrixRows`) を共有する。
 *
 * 目標レベル・目標達成時期は、self scope で development_plan の書込み権限が解決された場合のみ
 * (`development_plan_self_origin_enabled` テナント設定、§4-4-3) インライン編集可能なチップになる。
 * `not_linked_to_employee` の扱いは MyFamilyPage.tsx / routes/employee-family.ts の
 * `requireSelfEmployeeId` と同型 (§8-125、SkillMatrixSelfViewTable 内部で処理)。
 */
export function MySkillsPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-page-title text-text-main">自分のスキル・人材像</h1>
        <p className="text-sm text-text-sub mt-1">
          現状レベルの登録・変更は店長・管理者が行います。目標レベル・目標達成時期はお使いの権限に応じてご自身で設定できます。
        </p>
      </div>
      <SkillMatrixSelfViewTable />
    </div>
  );
}
